<template>
  <router-view/>

  <DynamicTranslationModal ref="translationModal"/>
</template>

<script setup lang="ts">
import DynamicTranslationModal from "@/components/modals/DynamicTranslationModal.vue";
</script>

<style lang="scss">

</style>